/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Franchises_Gamescount1Inputs */

const id_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("id", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} game`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} game`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const ms_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ms", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} permainan`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} permainan`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const da_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("da", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} spil`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} spil`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const de_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("de", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} Spiel`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} Spiele`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const en_us2_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en-US", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} game`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} games`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const es_es2_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es-ES", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} juego`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} juegos`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const es_mx2_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es-MX", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} juego`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} juegos`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const fil_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fil", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} laro`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} laro`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const fr_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fr", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} jeu`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} jeux`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const it_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("it", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} gioco`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} giochi`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const hu_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("hu", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} játék`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} játék`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const nl_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} game`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} games`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const no_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("no", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} spill`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} spill`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const pl_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} gra`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} gier`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const pt_br2_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt-BR", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Jogo ${i?.count}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Jogos ${i?.count}`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const pt_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} jogo`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} jogos`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const ro_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ro", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} joc`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} jocuri`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const fi_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} peli`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} peliä`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const sv_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("sv", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} spel`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} spel`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const vi_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("vi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} game`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} game`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const tr_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("tr", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} oyun`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} oyun`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const cs_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("cs", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} hra`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} her`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const bg_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("bg", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} игра`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} игри`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const ru_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ru", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} игра`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} игр(ы)`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const uk_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("uk", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} гра`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} ігор`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const ar_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ar", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} لعبة`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} لعبة`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const hi_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("hi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} गेम`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} गेम`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const th_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("th", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} เกม`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} เกม`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const ja_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ja", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} ゲーム`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} ゲーム`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const zh_cn2_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("zh-CN", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} 款游戏`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} 款游戏`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const zh_hant1_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("zh-Hant", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} 款遊戲`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} 款遊戲`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

const ko_franchises_gamescount1 = /** @type {(inputs: Franchises_Gamescount1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ko", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`게임 ${i?.count}개`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`게임 ${i?.count}개`);
	return /** @type {LocalizedString} */ ("franchises.gamesCount");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} game" |
* | "other" | "{count} games" |
*
* @param {Franchises_Gamescount1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const franchises_gamescount1 = /** @type {((inputs: Franchises_Gamescount1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchises_Gamescount1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_franchises_gamescount1(inputs)
	if (locale === "ms") return ms_franchises_gamescount1(inputs)
	if (locale === "da") return da_franchises_gamescount1(inputs)
	if (locale === "de") return de_franchises_gamescount1(inputs)
	if (locale === "en-US") return en_us2_franchises_gamescount1(inputs)
	if (locale === "es-ES") return es_es2_franchises_gamescount1(inputs)
	if (locale === "es-MX") return es_mx2_franchises_gamescount1(inputs)
	if (locale === "fil") return fil_franchises_gamescount1(inputs)
	if (locale === "fr") return fr_franchises_gamescount1(inputs)
	if (locale === "it") return it_franchises_gamescount1(inputs)
	if (locale === "hu") return hu_franchises_gamescount1(inputs)
	if (locale === "nl") return nl_franchises_gamescount1(inputs)
	if (locale === "no") return no_franchises_gamescount1(inputs)
	if (locale === "pl") return pl_franchises_gamescount1(inputs)
	if (locale === "pt-BR") return pt_br2_franchises_gamescount1(inputs)
	if (locale === "pt") return pt_franchises_gamescount1(inputs)
	if (locale === "ro") return ro_franchises_gamescount1(inputs)
	if (locale === "fi") return fi_franchises_gamescount1(inputs)
	if (locale === "sv") return sv_franchises_gamescount1(inputs)
	if (locale === "vi") return vi_franchises_gamescount1(inputs)
	if (locale === "tr") return tr_franchises_gamescount1(inputs)
	if (locale === "cs") return cs_franchises_gamescount1(inputs)
	if (locale === "bg") return bg_franchises_gamescount1(inputs)
	if (locale === "ru") return ru_franchises_gamescount1(inputs)
	if (locale === "uk") return uk_franchises_gamescount1(inputs)
	if (locale === "ar") return ar_franchises_gamescount1(inputs)
	if (locale === "hi") return hi_franchises_gamescount1(inputs)
	if (locale === "th") return th_franchises_gamescount1(inputs)
	if (locale === "ja") return ja_franchises_gamescount1(inputs)
	if (locale === "zh-CN") return zh_cn2_franchises_gamescount1(inputs)
	if (locale === "zh-Hant") return zh_hant1_franchises_gamescount1(inputs)
	return ko_franchises_gamescount1(inputs)
});
export { franchises_gamescount1 as "franchises.gamesCount" }